module.exports = __webpack_public_path__ + "img/blog-restore-gb-whatsapp-chats.0e858ce2.png";